<template>
  <div class="goodslistleft">
    <div class="goodslistleftcheckd">
      <template v-if="conditions[0] != undefined && conditions[0].id">
        <el-tag
          v-for="item in conditions"
          :key="item.id"
          @close="close(item.id)"
          closable
          :type="item.type"
        >
          {{ item.name }}
        </el-tag>
      </template>
      <el-row>
        <el-button round @click="reset">重置</el-button>
      </el-row>
    </div>

    <div class="goodslistleftattr">
      <!-- 产品子分类 -->
      <div class="goodslistleftattrtitle">
        {{
          checkboxList[0] && checkboxList[0]["attr"]
            ? checkboxList[0]["attr"]
            : "类型"
        }}
      </div>
      <div class="goodssearch">
        <goods-search
          :checkboxList="checkboxList"
          :checkList="checkboxchecked"
          @changeList="changeList"
          @changTab="changTab"
          type="class"
        />
      </div>

      <!--子分类-->
      <template v-if="sonCheckboxList.length > 0">
        <div class="goodslistleftattrtitle">
          {{ sonCheckboxList[0].attr ? sonCheckboxList[0].attr : "结构形式" }}
        </div>
        <div class="goodssearch">
          <goods-search
            :checkboxList="sonCheckboxList"
            :checkList="sonCheckboxchecked"
            @changeList="sonChangeList"
            @changTab="changTab"
            type="class"
          />
        </div>
      </template>

      <!--子分类的属性-->
      <template v-for="(attr, index) in attrboxList">
        <div class="goodslistleftattrtitle">
          {{ attr.name }}
        </div>
        <div class="goodssearch">
          <goods-search
            :checkboxList="attr.options"
            @changeList="changeList"
            @changTab="changTab"
            :index="index"
            :checkList="attr.checked"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import GoodsSearch from "./GoodsSearch.vue";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      conditions: [],
      checkboxList: [],
      attrboxList: [],
      checkboxchecked: [],
      sonCheckboxchecked: [],
      sonCheckboxList: [],
      sclassid: []
    };
  },
  components: { GoodsSearch },
  props: {
    classid: {
      type: Number,
      default: 3
    }
  },
  methods: {
    //删除标签
    close(id) {
      var index = this.conditions.findIndex(item => {
        if (item.id == id) {
          return true;
        }
      });
      if (this.conditions[index].class == "class") {
        this.checkboxchecked = [];
        this.attrboxList = [];
        this.sonCheckboxchecked = [];
        this.conditions = []; //index
        this.sonCheckboxList = [];
        this.savetag();
      } else {
        this.attrboxList[this.conditions[index].index].checked = [];

        this.conditions.splice(index, 1);

        if (this.conditions.length == 0) {
          this.attrboxList = [];
        }
      }
    },
    //删除所有标签
    reset() {
      this.sclassid = this.$route.params.classid;
      this.conditions = [];
      this.attrboxList = [];
      this.checkboxchecked = [];
      this.sonCheckboxchecked = [];
      this.sonCheckboxList = [];
      this.savetag();
    },
    //获取分类
    getclasslist(classid) {
      this.$api.goods.getgoodsclass(classid).then(res => {
        this.checkboxList = res.data.datas;
        if (this.sclassid > 1) {
          var index = this.checkboxList.findIndex(item => {
            if (item.id == this.sclassid) {
              return true;
            }
          });

          // var sons = [
          //     {
          //       id:711,
          //       name:"VR减速机"
          //     },
          //     {
          //       id:111,
          //       name:"私服点击"
          //     }
          // ]
          // this.checkboxList[0].son = sons

          this.changeList(index);
        }
      });
    },
    //通过分类， 获取属性
    changeList(val) {
      //获取分类下的属性
      this.checkboxchecked = [];
      this.sonCheckboxList = [];
      this.sonCheckboxchecked = [];
      this.checkboxchecked = [this.checkboxList[val].id];
      if (this.checkboxList[val].son && this.checkboxList[val].son.length > 0) {
        //console.log(this.checkboxList[val].son);
        this.sonCheckboxList = [...this.checkboxList[val].son];
        this.attrboxList = [];
        this.savetag();
      } else {
        this.$api.goods.getgoodsattr(this.checkboxList[val].id).then(res => {
          var mlist = res.data.datas;
          for (var i in mlist) {
            mlist[i].checked = [];
          }
          this.attrboxList = mlist;
          this.savetag();
        });
      }
    },
    sonChangeList(val) {
      // console.log("子分类")
      // console.log(this.checkboxchecked[0])
      this.sonCheckboxchecked = [];
      //   sonCheckboxchecked: [],
      // sonCheckboxList:[],
      // var index = this.sonCheckboxList.findIndex((item) => {
      //   if (item.id == this.sonCheckboxchecked[0]) {
      //     return true;
      //   }
      // });

      this.sonCheckboxchecked = [this.sonCheckboxList[val].id];
      this.$api.goods.getgoodsattr(this.sonCheckboxchecked[0]).then(res => {
        var mlist = res.data.datas;
        for (var i in mlist) {
          mlist[i].checked = [];
        }
        this.attrboxList = mlist;
        this.savetag();
      });
    },

    changTab(val, index) {
      this.attrboxList[index].checked = [];
      this.attrboxList[index].checked = [
        this.attrboxList[index].options[val].id
      ];
      this.savetag();
    },
    /**
     * 更新
     */
    savetag() {
      var mconditions = [];
      if (this.checkboxchecked.length > 0) {
        var index = this.checkboxList.findIndex(item => {
          if (item.id == this.checkboxchecked[0]) {
            return true;
          }
        });
        var citem = {
          name: this.checkboxList[index].name,
          type: "info",
          id: "class" + "-0-" + this.checkboxList[index].id,
          class: "class",
          mid: this.checkboxList[index].id
        };
      }
      mconditions.push(citem);

      //   sonCheckboxchecked: [],
      // sonCheckboxList:[],
      if (this.sonCheckboxList && this.sonCheckboxList.length > 0) {
        var index = this.sonCheckboxList.findIndex(item => {
          if (item.id == this.sonCheckboxchecked[0]) {
            return true;
          }
        });
        if (index >= 0) {
          var citem = {
            name: this.sonCheckboxList[index].name,
            type: "info",
            id: "class" + "-0-" + this.sonCheckboxList[index].id,
            class: "sonclass",
            mid: this.sonCheckboxList[index].id
          };

          mconditions.push(citem);
        }
      }

      for (var mindex in this.attrboxList) {
        if (this.attrboxList[mindex].checked.length > 0) {
          var index = this.attrboxList[mindex]["options"].findIndex(item => {
            if (item.id == this.attrboxList[mindex].checked[0]) {
              return true;
            }
          });
          var citem = {
            name: this.attrboxList[mindex]["options"][index].name,
            type: "info",
            id:
              "info" +
              "-" +
              mindex +
              "-" +
              this.attrboxList[mindex]["options"][index].id,
            class: "info",
            mid: this.attrboxList[mindex]["options"][index].id,
            index: mindex
          };
          mconditions.push(citem);
        }
      }
      this.goodsWhere(mconditions);
      // console.log(mconditions)
      this.conditions = mconditions;
    },
    ...mapActions(["goodsWhere"])
  },
  mounted() {
    var classid = this.$route.params.pid;
    this.sclassid = this.$route.params.classid;
    this.getclasslist(classid);
  }
};
</script>

<style scoped>
.goodslistleft {
  width: 240px;
  background-color: #fff;
  padding-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  float: left;
}
.goodslistleftcheckd {
  width: 228px;
  border-bottom: 1px solid #c1c1c1;
  padding-left: 12px;
  padding-top: 16px;
}
.goodslistleftcheckd span {
  margin-right: 5px;
  margin-bottom: 5px;
}
.goodslistleft >>> .el-tag {
  height: 22px;
  font-size: 13px;
  line-height: 22px;
}
.goodslistleft >>> .el-button,
.goodslistleft >>> .el-button--default {
  margin-right: 14px;
  float: right;
  padding: 7px 24px;
  margin-bottom: 10px;
  color: #fff;
  background-color: #fbb113;
}
.goodslistleft >>> .el-button:hover {
  color: #fff;
  background-color: #fbb113;
}
.goodslistleft >>> .el-button:focus {
  color: #fff;
  background-color: #fbb113;
}

.goodslistleftattr {
  width: 216px;
  margin-left: 12px;
}
.goodslistleftattrtitle {
  margin-top: 20px;
  font-size: 20px;
  color: #666666;
  margin-bottom: 7px;
}
.goodssearch {
  /* overflow-y:scroll;  */
  overflow-x: hidden;
  max-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/GoodsListLeft.vue